import Container from "../ui/Container";
import SectionHeader from "../ui/SectionHeader";
import FAQItem from "./FAQItem";

export default function FAQ() {
    const faqs = [
        { question: "How to apply for a loan?", answer: "You can apply online or contact our support team." },
        { question: "Do you provide LIC loans?", answer: "Yes, we provide LIC-based loan solutions." },
        { question: "Is Thawa service safe?", answer: "Absolutely, our thawa services are secure and trusted." },
    ];

    return (
        <section id="faq" className="py-16">
            <Container>
                <SectionHeader title="FAQ" subtitle="Frequently Asked Questions" />
                <div className="space-y-4">
                    {faqs.map((f, i) => (
                        <FAQItem key={i} question={f.question} answer={f.answer} />
                    ))}
                </div>
            </Container>
        </section>
    );
}
